require('angular/angular.min');
require('angular-ui-router');
import 'data-ng-authentication';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-authentication/src/vendor.ts